import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  Box, Stack, Typography,
} from '@mui/material';
import {
  Storefront as StorefrontIcon,
} from '@mui/icons-material';
import { DataSignalsIcon } from '../global/CustomIcons';

import SignalList from '../../containers/signal_SignalList';
import RecordEventDialog from './RecordEventDialog';
import PageBreadcrumbs from '../common/PageBreadcrumbs';
import { CMButton } from '../../containers/styledComponents';
import { fetchRequest as signalFetchAll } from '../../redux/actions/signals/list';

const SignalsPage = () => {
  const [recordEventOpen, setRecordEventOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Events are interleaved into the signals list — refresh page 1 after a
  // record so the new (pending → scored) event shows up with its Event badge.
  const handleEventRecorded = () => {
    dispatch(signalFetchAll({ page: 1, rowsPerPage: 12, query: '' }));
  };

  return (
    <Box
      sx={{
        width: '100%',
        position: 'relative',
        mb: 4
      }}
    >
      {/* Header */}
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ sm: 'flex-start' }}
        justifyContent="space-between"
        spacing={1}
        sx={{ mb: 1.5 }}
      >
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <PageBreadcrumbs
            items={[
              { text: "Data Signals", icon: <DataSignalsIcon /> }
            ]}
            mb={0.5}
          />
          <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
            Every column ingested into your workspace becomes a signal — explore distributions, relevance, and relationships at a glance.
          </Typography>
        </Box>
        {/* Offset applied to the button itself (relative position) so MUI
            Stack's spacing/margin handling can't clobber it — pushes it down
            to line up with the "Data Signals" title row on the left. */}
        <Stack direction="row" spacing={1.25} sx={{ flexShrink: 0 }}>
          {/* "Record an event" now lives as a compact "+" in the Data Signals
              table header (rows view). "My listings" lives in the user menu
              under "Monetization" — keep the header focused on the marketplace. */}
          <CMButton
            startIcon={<StorefrontIcon />}
            onClick={() => navigate('/marketplace')}
            sx={{ position: 'relative', top: { sm: 28 } }}
          >
            Marketplace
          </CMButton>
        </Stack>
      </Stack>

      <RecordEventDialog
        open={recordEventOpen}
        onClose={() => setRecordEventOpen(false)}
        onRecorded={handleEventRecorded}
      />

      {/* Content — single view. Correlations + causality live on the
          Relationships page and the AI insights feed on the Discovery page
          (both sidebar · Intelligence). */}
      <Box sx={{ px: 0, mb: 7.5 }}>
        <SignalList onRecordEvent={() => setRecordEventOpen(true)} />
      </Box>
    </Box>
  );
};

export default SignalsPage;
